module.exports = __webpack_public_path__ + "img/common_statPOS.37554cbe.svg";